var refer_src = "//popchart.co/cdn/shop/t/38/assets/swell-refer-campaign.jpg?v=47281654649203158851783031962";
var refer_src_mob = "//popchart.co/cdn/shop/t/38/assets/swell-refer-campaign-mobile.png?v=98881251247622939131783031962";
(function() {
  $(document).ready(function() {
    // SwellConfig.Link.initializeLinks(".swell-link-login, .swell-link-register");
    // SwellConfig.LocalStorage.initializeLocalStorage();
  	$(document).on("click",".swell-referral-form-list-submit", function(){
      temp_email = $('#swell-referral-refer-emails').val();
    });
    $(document).on("click", ".swell-share-referral-copy", function() {
      setTimeout(function(){
        detachReferralCopy();
        // $(".swell-referral-copy-main").prepend("<div class='close-container'></div>");
        // $(".swell-referral-copy-main .close-container").html($(".swell-referral-copy-main .swell-referral-back-link").detach());
        $(".swell-referral-copy-link").html($(".swell-referral-copy-link").html().replace("http://",""));
      },20);
    });

    $(document).on("click", ".swell-referral-back-link", function() {
      $(".swell-referral").removeClass("thankyou");
      $(".swell-referral-sidebar-details").show();
      $(".checkout-heading .thanks-heading").css("display","inline-block");
    });
    $(document).on("click", ".swell-referral-back-link.checkout", function() {
    	$(".pop-chart-labs-rewards").hide();
    });
	});
  $(document).on("swell:setup", function() {
  	if($(".campaigns").length>0){
	  	Swell.Campaign.initializeCampaigns(".campaigns", SwellConfig.Campaign.opts);
	  	$(".campaigns .swell-campaign:last-child").after('<li class="refer"> <img class="banner-desktop" src="'+refer_src+'"><img class="banner-mobile" src="'+refer_src_mob+'"> <div class="text-section"> <div class="inner-holder"> <h2>Refer a Friend</h2> <p>Refer a friend and get $20.</p> <a href="/pages/refer">Start Referring Now</a> </div> </div> </li>');
	  	// detachReferCampaign();
  	}
  	if($(".premium-tiers").length>0){
	  	if(spapi.activeVipTiers.length>1){
		  	$(".tier1-title").html(spapi.activeVipTiers[0].name);
		  	$(".tier2-title").html(spapi.activeVipTiers[1].name);
		  	$(".tier1-spend").html("$"+spapi.activeVipTiers[0].amount_spent_cents/100+"-"+spapi.activeVipTiers[1].amount_spent_cents/100);
		  	$(".tier2-spend").html("$"+spapi.activeVipTiers[1].amount_spent_cents/100+"+");
	  	}
	  	else{
		  	$(".tier1-title").html("Design Dabbler");
		  	$(".tier2-title").html("Design Genius");
		  	$(".tier1-spend").html("$150-250");
		  	$(".tier2-spend").html("$250+");
	  	}
	  	if(spapi.authenticated){
		  	var rank = getCustomerTierRank();
		  	if(rank == 0){
		  		$(".swell-tier-1").addClass("active");
		  	}
		  	else if(rank == 1){
		  		$(".swell-tier-2").addClass("active");
		  	}
	  	}
  	}
  	if($(".swell-discounts").length>0){
	  	var options = spapi.activeRedemptionOptions;
	  	for(var t=0;t<options.length;t++){
	  		$(".swell-discounts").append("<li><h2>"+options[t].prettyDiscount+"</h2><h3>"+options[t].cost_text+"</h3></li>");
	  	}
  	}
  	if($(".swell-referral").length>0)
    {
      SwellConfig.Referral.initializeReferral(".swell-referral");
      // if(spapi.isMobile) {
      //   $(".swell-share-referral-facebook").after('');
      // }
    }
  
    if(spapi.authenticated || (spapi.customer.referral_receipts && spapi.customer.referral_receipts.length > 0)) {
      setupReferrals();
    }
    if(spapi.authenticated){
    	$(".swell-referral").addClass("logged-in");
    }

    $(document).on("swell:referral:success", function(jqXHR, textStatus, errorThrown) {
      thankyou();
      $(".checkout-heading .thanks-heading").hide();
    });

    $(document).on("swell:referral:error", function(jqXHR, textStatus, errorThrown) {
      if(textStatus && textStatus === "EMAILS_ALREADY_PURCHASED"){
        $(".refer-customer-error").remove();
        $(".swell-referral-sidebar-details").show();
        $(".swell-referral").removeClass("thankyou");
        $(".swell-referral-content-container").addClass("error-message");
        $(".swell-referral-form-body").prepend('<p class="refer-customer-error">Sorry! Looks like this person has already made a purchase. Try referring another friend.</p>');
        $("#swell-referral-refer-emails").addClass("error-border");
        $("#swell-referral-refer-submit").addClass("error-border");
      }
      else if(textStatus && textStatus === "Please enter a valid email address"){
        $(".refer-customer-error").remove();
        $(".swell-referral-sidebar-details").show();
        $(".swell-referral").removeClass("thankyou");
        $(".swell-referral-content-container").addClass("error-message");
        $(".swell-referral-form-body").prepend('<p class="refer-customer-error">Please enter valid email addresses seperated with commas</p>');
        $("#swell-referral-refer-emails").addClass("error-border");
        $("#swell-referral-refer-submit").addClass("error-border");
      }
    });

    $('body').on('click', '.swell-referral-copy', function(e){
      if($(e.target).hasClass("swell-referral-copy")) {
        e.stopPropagation();
      }
    });

    if($("#swell-checkout-redemption-options").length>0){
      $("#swell-checkout-redemption-options").prepend("<option value=\"-1\">Choose your reward</option>");
      $("#swell-checkout-redemption-options").val("-1");
    }

    $(".swell-loader").hide();
    $(".pop-chart-labs-rewards").css("display","flex");
    // $(".inner-holder").css("display","flex");
	});
}).call(this);

// campaigns
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Campaign = {
    opts: {
      templates: {
        campaign: "<li class='swell-campaign'> <div class='swell-campaign-content' data-display-mode='modal' data-campaign-id='<%=campaign.id %>'> <div class='swell-campaign-icon'> <span class='swell-campaign-icon-content'> <i class='fa <%=campaign.icon %>'><span class='path1'></span><span class='path2'></span><span class='path3'></span></i> </span> </div> <span class='campaign-text-holder'><div class='swell-campaign-value'> <span class='swell-campaign-value-content'><%=campaign.reward_text %></span> </div> <div class='swell-campaign-type'> <span class='swell-campaign-type-content'><%=campaign.title %></span> </div> </div> </div> </li>"
      }
    }
  };
}).call(this);

function getCustomerTierRank() {
  var customer_tier, intro_tier, rank, tiers;
  rank = null;
  customer_tier = spapi.customer.vip_tier;
  tiers = spapi.activeVipTiers;
  if (customer_tier && customer_tier.id) {
    rank = $.grep(tiers, function(e) {
      return e.id === customer_tier.id;
    })[0].rank;
    return rank;
  } else {
    intro_tier = $.grep(tiers, function(e) {
      return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
    });
    if (intro_tier.length > 0) {
      return intro_tier[0].rank;
    } else {
      return null;
    }
  }
}


// referral
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Referral = {
    opts: {
      localization: {
        referralSidebarDetailsAction: "",
        referralSidebarDetailsReward: "",

        referralRegisterHeading: "Give 20%, Get $20",
        referralRegisterFormDetails: "Enter your email to get started.",
        referralRegisterFormEmail: "Enter email.....",
        referralRegisterFormSubmit: "Next ->",
        referralRegisterDetails: "<%= referralCampaign.details %>",

        referralReferHeading: "Give 20%, Get $20",
        referralReferFormEmails: "Your friends' emails (separated by commas)",
        referralReferFormSubmit: "Send ->",
        referralReferFormDetails: "Now, enter your friends' email.",
        referralReferFormEmailsDetails: "",
        referralReferDetails: "<%= referralCampaign.details %>",

        referralReferMediaDetails: "You can also share your link with the buttons below:",

        referralShareFacebook: "Share",
        referralShareCopy: "Copy Link",
        referralShareSMS: "SMS",
        referralShareMessenger: "Message",

        referralFacebookIcon: "swell-icon-facebook1",
        referralLinkIcon: "swell-icon-link",
        referralSMSIcon: "swell-icon-message",
        referralMessengerIcon: "swell-icon-messenger",

        referralThanksHeading: "Thanks for Referring!",
        referralThanksDetails: "Remind your friends to check their emails.",

        referralCopyHeading: "Copy Link",
        referralCopyButton: "Copy Link ->",
        referralCopyDetails: "Copy link and share with your friends."
      },
      templates: {
        referralRegister: '<div class="swell-referral-register"> <h2 class="swell-referral-heading"><%= localization.referralRegisterHeading %></h2> <div class="swell-referral-details-container"><p class="swell-referral-details"><%= localization.referralRegisterDetails %></p></div> <div class="swell-referral-form-wrapper"> <form name="swell-referral-register-form" class="swell-referral-form" id="swell-referral-register-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralRegisterFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="email" name="swell-referral-register-email" id="swell-referral-register-email" required="required" placeholder="<%= localization.referralRegisterFormEmail %>"> </li> <li class="swell-referral-form-list-button"> <div class="swell-referral-form-footer"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-register-submit" id="swell-referral-register-submit" value="<%= localization.referralRegisterFormSubmit %>"> </div> </li> </ul> </div> </form> </div> </div>',
        referralRefer: '<div class="swell-referral-refer"> <h2 class="swell-referral-heading"><%= localization.referralReferHeading %></h2> <div class="swell-referral-details-container"><p class="swell-referral-details"><%= localization.referralReferDetails %></p></div> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralReferFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="text" name="swell-referral-refer-emails" id="swell-referral-refer-emails" required="required" placeholder="<%= localization.referralReferFormEmails %>"> <span class="swell-referral-form-field-details"><%= localization.referralReferFormEmailsDetails %></span> </li> <li class="swell-referral-form-list-button"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit" value="<%= localization.referralReferFormSubmit %>"> </li> </ul> </div> </form> </div> <div class="swell-referral-media-wrapper"> <p class="swell-referral-media-details"><%= localization.referralReferMediaDetails %></p> <ul class="swell-referral-media-list"> <li class="swell-referral-medium swell-share-referral-facebook"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralFacebookIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareFacebook %> </div> </li> <li class="swell-referral-medium swell-share-referral-sms"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-icon-sms" aria-hidden="true"></i>&nbsp;SMS </div> </li> <li class="swell-referral-medium swell-share-referral-messenger"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralMessengerIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareMessenger %> </div> </li> <li class="swell-referral-medium swell-share-referral-copy"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralLinkIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareCopy %> </div> </li> </ul> </div> </div>'
      }
    },
    initializeReferral: function(containerSelector) {
      var email = $(containerSelector).data("customer-email");
      if (email) {
        spapi.storage.setItem("referrer_email", email);
        spapi.customer.email = email;
      }
      Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
      $(".boku-post-checkout").css("display","flex");
      $(".swell-referral").show();
    }
  };
}).call(this);

function setupReferrals (){
  $(".swell-referral-content").css("display","flex");
  $(".border").show();
  if(spapi.customer.referral_receipts.length > 0) {
    $(".referral-table").show();

    referrals = spapi.customer.referral_receipts;

    referrals.forEach(function(referral) {
      status = null;

      if(referral.completed_at){ 
        status = "Purchased ($20 earned)";
      } else {
        status = "Invited";
      }

      $(".swell-referral-table tbody").append('<tr> <td> <div class="trucate-email">' +  referral.email + '</div></td><td>' + status +'</td></tr>');
    });  
  }
}

function detachReferralCopy(){
  if($(".swell-referral-copy").length > 0){
  	if($(".pop-chart-labs-rewards").length > 0){
    	$(".pop-chart-labs-post-checkout").append($(".swell-referral-copy").detach());
  	}
  	else{
    	$(".referral-holder .inner-holder").append($(".swell-referral-copy").detach());
  	}
  }
}

function thankyou(){
  $(".swell-referral-sidebar-details").hide();
  $(".swell-referral").addClass("thankyou");
  if($(".swell-referral-table").length>0){
    $(".swell-referral-table tbody").append("<tr><td>"+temp_email+"</td><td>Invited</td></tr>");
  }
}


// links
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Link = {
    initializeLinks: function(containerSelector) {
      return $(document).on("click", containerSelector, function(e) {
        var href;
        e.preventDefault();
        href = $(this).attr("href");
        localStorage.setItem("swell-location", "/pages/rewards");
        return window.location = href;
      });
    }
  };
}).call(this);


// local storage
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.LocalStorage = {
    initializeLocalStorage: function() {
      var location;
      location = localStorage.getItem("swell-location");
      if (location && window.location.pathname === '/account') {
        localStorage.removeItem("swell-location");
        return window.location = location;
      }
    }
  };
}).call(this);

// $(window).resize(function(){
// 	detachReferCampaign();
// });

// function detachReferCampaign(){
// 	if($(window).width()<767){
// 		if(!$(".campaigns > .refer").hasClass("mobile")){
// 			$(".campaigns > .refer").detach();
// 			$(".campaigns .swell-campaign:last-child").after('<li class="refer mobile"> <img src="'+refer_src_mob+'"> <div class="text-section"> <div class="inner-holder"> <h2>Refer a Friend</h2> <p>Refer a friend and get $10.</p> <a href="/pages/refer">Start Referring Now</a> </div> </div> </li>');
// 		}
// 	}
// 	else{
// 		if($(".campaigns > .refer").hasClass("mobile")){
// 			$(".campaigns > .refer").detach();
// 			$(".campaigns .swell-campaign:last-child").before('<li class="refer"> <img src="'+refer_src+'"> <div class="text-section"> <div class="inner-holder"> <h2>Refer a Friend</h2> <p>Refer a friend and get $10.</p> <a href="/pages/refer">Start Referring Now</a> </div> </div> </li>');
// 		}
// 	}
// }